<template>
    <tr class="sub-child-row">
        <v-lazy
            v-for="(header, index) in headers"
            :key="index"
            tag="td"
            :class="'text-' + header.align"
            style="height:20px;"
            :style="headerHasBorder(header.value) ? 'border-bottom: 1px solid rgba(0, 0, 0, 0.12)' : 'border: 0'"
        >
            <div
                :class="header.class"
                class="main--text body-2"
            >
                <span v-if="header.value === 'avatar'">
                    <v-row
                        no-gutters
                        class="fill-height"
                    >
                        <v-col style="min-width: 307px; width: 307px; max-width: 307px;">
                            <v-row
                                align="center"
                                style="flex-wrap: nowrap"
                            >
                                <div style="width: 91px; min-width: 91px"></div>
                                <span
                                    class="caption text-none text-truncate font-weight-medium grey--text text--darken-4 mr-2"
                                    style="cursor: pointer;"
                                    @click="onItemTitleClick(item)"
                                >
                                    {{ getSubChildTitle(item) }}
                                </span>
                            </v-row>
                        </v-col>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'flextime_period'">
                    <v-row
                        no-gutters
                        align="center"
                        :justify="header.justify"
                    >
                        <span
                            class="grey--text text--darken-4 caption font-weight-medium tabular-nums"
                        >
                            {{ formatDate(item.sub_group_id) }}
                        </span>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'flextime_office_time'">
                    <v-row
                        no-gutters
                        align="center"
                        :justify="header.justify"
                    >
                        <span
                            class="grey--text text--darken-4 caption font-weight-medium tabular-nums"
                        >
                            {{ item.flextime_office_time ? formatTimeDuration(item.flextime_office_time) : '' }}
                        </span>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'flextime_office_agreed_time'">
                    <v-row
                        no-gutters
                        align="center"
                        :justify="header.justify"
                    >
                        <span
                            class="grey--text text--darken-4 caption font-weight-medium tabular-nums"
                        >
                            {{ item.flextime_office_agreed_time ? formatTimeDuration(item.flextime_office_agreed_time) : '' }}
                        </span>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'flextime_office_percent'">
                    <v-row
                        no-gutters
                        align="center"
                        :justify="header.justify"
                    >
                        <span
                            class="grey--text text--darken-4 caption font-weight-medium tabular-nums"
                        >
                            {{ item.flextime_office_percent ? formatPercent(item.flextime_office_percent) : '' }}
                        </span>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'flextime_balance'">
                    <v-row
                        no-gutters
                        align="center"
                        :justify="header.justify"
                    >
                        <span v-if="item.flextime_balance" class="grey--text text--darken-4 caption font-weight-medium tabular-nums">
                            {{ formatFlextimeDuration(item.flextime_balance) }}
                        </span>
                        <div
                            v-else
                            class="progress-wrapper"
                            style="height: 7px; width: 27px"
                        ></div>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'total'">
                    <v-row
                        no-gutters
                        align="center"
                        :justify="header.justify"
                    >
                        <span
                            v-if="item.total"
                            class="grey--text text--darken-4 caption font-weight-medium tabular-nums"
                        >
                            {{ formatTimeDuration(item.total) }}
                        </span>
                        <div
                            v-else
                            class="progress-wrapper"
                            style="height: 7px; width: 27px"
                        ></div>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'flextime_expected'">
                    <v-row
                        no-gutters
                        align="center"
                        :justify="header.justify"
                    >
                        <span v-if="item.flextime_expected !== null" class="grey--text text--darken-4 caption font-weight-medium tabular-nums">
                            {{ formatTimeDuration(item.flextime_expected) }}
                        </span>
                        <div
                            v-else
                            class="progress-wrapper"
                            style="height: 7px; width: 27px"
                        ></div>
                    </v-row>
                </span>
                <span v-else-if="header.value === 'flextime_balance'">
                    <v-row
                        no-gutters
                        align="center"
                        :justify="header.justify"
                    >
                        <span v-if="item.flextime_expected !== null" class="grey--text text--darken-4 caption font-weight-medium tabular-nums">
                            {{ formatFlextimeDuration(item.flextime_balance) }}
                        </span>
                        <div
                            v-else
                            class="progress-wrapper"
                            style="height: 7px; width: 27px"
                        ></div>
                    </v-row>
                </span>
                <v-row
                    v-else
                    no-gutters
                    :justify="header.justify"
                    class="fill-height"
                >
                    <span
                        v-if="item[header.value]"
                        class="caption"
                    > {{ formatByHeader(item[header.value], header) }}</span>
                    <div
                        v-else-if="headerHasBorder(header.value)"
                        class="progress-wrapper"
                        style="height: 7px; width: 27px"
                    ></div>
                </v-row>
            </div>
        </v-lazy>
    </tr>
</template>

<script>
import {$t} from "@/i18n";
import ReportModule from "../../store/modules/report";
import BookmarkModule from "../../store/modules/bookmark";
import ReportDefaultColumns from "./ReportDefaultColumns";
import {
    formatDateShort,
    formatWeekdayShort,
    formatDateCustom,
    parseSysDate,
    parseSysDateTime,
    formatTime,
    calcDateEquals,
    formatDate,
    formatTimeDuration,
    formatFlextimeDuration,
    formatByHeader,
    formatPercent
} from "@/plugins/formatting";
import AppModule from "@/store/modules/app";

export default {
    name: "ReportFlextimeSummaryChildRow",
    props: {
        headers: {
            type: Array,
            default: () => []
        },
        item: {
            type: Object,
            required: true
        },
        primaryValue: {
            type: Number,
            default: 0
            // percentageFromMax(item)
        },
        secondaryValue: {
            type: Number,
            default: 0
            // extraPercentage(item)
        },
        grouping: {
            type: String,
            required: true
        },
        parentId: {
            type: [String, Number],
            required: true
        },
        urlAdapter: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const {default_task_columns} = ReportDefaultColumns();
        const appModule = AppModule();
        const {navigate_report_default_route} = BookmarkModule();
        const {topics_map, calcExtraColumnValue} = ReportModule();
        const getSubChildTitle = subchild => {
            if (!subchild || !subchild.sub_group_id) return "false";

            return formatWeekdayShort(parseSysDate(subchild.sub_group_id))
        };
        const onItemTitleClick = item => {
            let queryParams = {}
            let add_dates_list = true;
            const current_grouping = String(props.grouping).split(";");
            const primary_grouping = current_grouping[0];
            const secondary_grouping = current_grouping[1];

            if (primary_grouping === "client") {
                queryParams = Object.assign(queryParams, {
                    client_id_list: Number(props.parentId.split("_")[1])
                });
            } else if (primary_grouping === "assignee") {
                queryParams = Object.assign(queryParams, {
                    person_id_list: Number(props.parentId)
                });
            } else if (primary_grouping === "date") {
                add_dates_list = false;
                queryParams = Object.assign(queryParams, {
                    dates_list: [props.parentId, props.parentId]
                });
            }

            if (secondary_grouping === "topic") {
                queryParams = Object.assign(queryParams, {
                    topic_id_list: item.sub_group_id
                });
            } else if (secondary_grouping === "assignee") {
                queryParams = Object.assign(queryParams, {
                    person_id_list: Number(item.sub_group_id)
                });
            } else if (secondary_grouping === "client") {
                queryParams = Object.assign(queryParams, {
                    client_id_list: Number(item.sub_group_id.split("_")[1])
                });
            } else if (secondary_grouping === "title") {
                queryParams = Object.assign(queryParams, {
                    keyword: item.sub_group_id
                });
            } else if (secondary_grouping === "date") {
                add_dates_list = false;
                queryParams = Object.assign(queryParams, {
                    dates_list: [item.sub_group_id, item.sub_group_id]
                });
            }

            if (add_dates_list) {
                queryParams = Object.assign(queryParams, {
                    dates_list: props.urlAdapter.getUrlParameter("dates_list")
                });
            }

            queryParams = Object.assign(queryParams, {
                view: "detailed",
                columns: default_task_columns,
                groupBy: props.grouping,
            });
            navigate_report_default_route(queryParams);
        };

        const headerHasBorder = (headerName) => {
            const borderHeaders = [
                'flextime_balance',
                'flextime_expected',
                'total',
                'tasks_count',
                'flextime_period',
                'flextime_office_time',
                'flextime_office_agreed_time',
                'flextime_office_percent'
            ]

            return borderHeaders.includes(headerName)
        }

        return {
            calcExtraColumnValue,
            getSubChildTitle,
            onItemTitleClick,
            formatTimeDuration,
            headerHasBorder,
            formatFlextimeDuration,
            formatDate,
            formatByHeader,
            formatPercent
        };
    }
};
</script>
